import React, { useState } from 'react';
import './Certificates.css';

const Certificates = () => {
    const [selectedCert, setSelectedCert] = useState(null);

    const certificates = [
        {
            id: 1,
            title: 'Bachelor of Science',
            institution: 'University of Arizona Global Campus',
            field: 'Information Technology',
            date: 'August 25, 2025',
            dateLabel: 'Graduated',
            image: '/certificates/certificate_1.jpeg',
            description: 'Comprehensive degree program covering advanced IT concepts, systems design, and technology management.',
            honors: 'Magna Cum Laude'
        },
        {
            id: 2,
            title: 'Associate in Arts',
            institution: 'Strayer University',
            field: 'Information Technology',
            date: 'December 19, 2022',
            dateLabel: 'Graduated',
            image: '/certificates/certificate_2.jpeg',
            description: 'Foundation degree focused on core IT principles, programming, and network fundamentals.',
            honors: 'Honors Scholar'
        },
        {
            id: 3,
            title: 'NYS Security & Fire Alarm License',
            institution: 'State of New York Department of State',
            field: 'Installing, Servicing, or Maintaining Security or Fire Alarm Systems',
            date: 'June 25, 2026 – June 24, 2028',
            dateLabel: 'Effective Term',
            image: '/certificates/certificate_3.jpeg',
            description: 'Official License & Qualification from the Division of Licensing Services under Article 6D of the General Business Law to engage in the business of installing, servicing, or maintaining security or fire alarm systems.',
            honors: 'NYS Licensed Qualifier'
        }
    ];

    return (
        <div className="certificates-page">
            {/* Hero Section */}
            <section className="certificates-hero">
                <div className="container">
                    <h1 className="page-title fade-in">Professional Certifications & Licenses</h1>
                    <p className="page-subtitle fade-in">
                        Demonstrating commitment to technical excellence and compliance through accredited education and state licensing
                    </p>
                </div>
            </section>

            {/* 🎓 Professional Achievement Section */}
            <section className="certificates-intro section">
                <div className="container">
                    <div className="intro-content">
                        <h2 className="section-title">Academic & Professional Excellence</h2>
                        <p className="intro-text">
                            Our team combines rigorous academic training with official state licensing.
                            These credentials represent dedicated study and legal authorization in information
                            technology, systems architecture, and security/fire alarm installation—directly
                            guaranteeing high-quality, compliant surveillance and security solutions for our clients.
                        </p>
                    </div>
                </div>
            </section>

            {/* Certificates Grid */}
            <section className="certificates-grid-section section">
                <div className="container">
                    <div className="certificates-grid">
                        {certificates.map((cert) => (
                            <div key={cert.id} className="certificate-card">
                                <div 
                                    className="certificate-image-wrapper"
                                    onClick={() => setSelectedCert(cert)}
                                    title="Click to expand view"
                                >
                                    <img
                                        src={cert.image}
                                        alt={`${cert.title} from ${cert.institution}`}
                                        className="certificate-image"
                                    />
                                    <div className="certificate-zoom-overlay">
                                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="11" cy="11" r="8"></circle>
                                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                            <line x1="11" y1="8" x2="11" y2="14"></line>
                                            <line x1="8" y1="11" x2="14" y2="11"></line>
                                        </svg>
                                        <span>Click to Zoom</span>
                                    </div>
                                </div>

                                <div className="certificate-details">
                                    <div className="certificate-header">
                                        <h3 className="certificate-title">{cert.title}</h3>
                                        {cert.honors && (
                                            <span className="certificate-honors">
                                                <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px', verticalAlign: 'middle', display: 'inline-block' }}>
                                                    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
                                                    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
                                                    <path d="M4 22h16" />
                                                    <path d="M10 14.66V17c0 .55-.45 1-1 1H4v2h16v-2h-5c-.55 0-1-.45-1-1v-2.34" />
                                                    <path d="M12 2a7 7 0 0 1 7 7c0 2.6-1.5 4.9-3.7 6H8.7C6.5 13.9 5 11.6 5 9a7 7 0 0 1 7-7z" />
                                                </svg>
                                                {cert.honors}
                                            </span>
                                        )}
                                    </div>

                                    <div className="certificate-meta">
                                        <p className="certificate-institution">
                                            <span className="meta-icon">
                                                <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="meta-icon-svg" style={{ color: '#0d9488' }}>
                                                    <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                                                    <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5" />
                                                </svg>
                                            </span>
                                            {cert.institution}
                                        </p>
                                        <p className="certificate-field">
                                            <span className="meta-icon">
                                                <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="meta-icon-svg">
                                                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                                                    <line x1="8" y1="21" x2="16" y2="21" />
                                                    <line x1="12" y1="17" x2="12" y2="21" />
                                                </svg>
                                            </span>
                                            {cert.field}
                                        </p>
                                        <p className="certificate-date">
                                            <span className="meta-icon">
                                                <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="meta-icon-svg">
                                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                                    <line x1="16" y1="2" x2="16" y2="6" />
                                                    <line x1="8" y1="2" x2="8" y2="6" />
                                                    <line x1="3" y1="10" x2="21" y2="10" />
                                                </svg>
                                            </span>
                                            {cert.dateLabel ? `${cert.dateLabel}: ` : 'Graduated: '}{cert.date}
                                        </p>
                                    </div>

                                    <p className="certificate-description">{cert.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Modal Lightbox */}
            {selectedCert && (
                <div className="cert-modal-backdrop" onClick={() => setSelectedCert(null)}>
                    <div className="cert-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="cert-modal-close" onClick={() => setSelectedCert(null)}>
                            &times;
                        </button>
                        <h3 className="cert-modal-title">{selectedCert.title}</h3>
                        <p className="cert-modal-subtitle">{selectedCert.institution}</p>
                        <div className="cert-modal-image-container">
                            <img src={selectedCert.image} alt={selectedCert.title} className="cert-modal-image" />
                        </div>
                    </div>
                </div>
            )}

            {/* Trust & Credibility Section */}
            <section className="credibility-section section">
                <div className="container">
                    <div className="credibility-content">
                        <h2 className="section-title">Why Our Credentials Matter</h2>
                        <div className="credibility-grid">
                            <div className="credibility-item">
                                <div className="credibility-icon">
                                    <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                    </svg>
                                </div>
                                <h3>Technical Expertise</h3>
                                <p>Formal training in IT systems, network security, and infrastructure design ensures we implement industry best practices.</p>
                            </div>
                            <div className="credibility-item">
                                <div className="credibility-icon">
                                    <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                        <polyline points="22 4 12 14.01 9 11.01" />
                                    </svg>
                                </div>
                                <h3>Quality Assurance & Compliance</h3>
                                <p>Academic rigor and state licensing ensure legal compliance and meticulous attention to detail in every surveillance installation.</p>
                            </div>
                            <div className="credibility-item">
                                <div className="credibility-icon">
                                    <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="10" />
                                        <circle cx="12" cy="12" r="6" />
                                        <circle cx="12" cy="12" r="2" />
                                    </svg>
                                </div>
                                <h3>Continuous Learning</h3>
                                <p>Our commitment to education means we stay current with emerging security technologies, regulations, and methodologies.</p>
                            </div>
                            <div className="credibility-item">
                                <div className="credibility-icon">
                                    <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                </div>
                                <h3>Professional Standards</h3>
                                <p>Certified and licensed professionals bring accountability and adherence to ethical standards in all client engagements.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Certificates;
